export default {"src":"/_next/static/media/okra.c191df88.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};